import KdiagramCalculationResultLineParametersData from "./data";

export default function mapLineParametersFromJson(json) {
  return new KdiagramCalculationResultLineParametersData(
    json["rpm_power_line_parameters"]["rpm_power_a_parameter"],
    json["rpm_power_line_parameters"]["rpm_power_b_parameter"],
    json["rpm_speed_line_parameters"]["rpm_speed_a_parameter"],
    json["rpm_speed_line_parameters"]["rpm_speed_b_parameter"],
    json["stw_power_line_parameters"]["stw_power_a_parameter"],
    json["stw_power_line_parameters"]["stw_power_b_parameter"],
    json["stw_rpm_line_parameters"]["stw_rpm_a_parameter"],
    json["stw_rpm_line_parameters"]["stw_rpm_b_parameter"],
    json["r2_rpm_power"],
    json["r2_rpm_speed"],
  );
}
